import { PRODUCT_ID_PATTERN } from "./collection-model.js";
import { FREE_DELIVERY_THRESHOLD_CENTS } from "./delivery.js";
export { FREE_DELIVERY_THRESHOLD_CENTS } from "./delivery.js";

export function catalogMatches(product, query = "") {
  const normalize = (value) => String(value).toLocaleLowerCase("uk-UA").normalize("NFKC").replace(/no\.?\s*|№\s*/g, "").trim();
  const search = normalize(query).split(/\s+/).filter(Boolean);
  const collection = [product.collection === "wedding" ? "весільний весільні wedding bridal" : product.collection === "autumn" ? "осінній осінні autumn fall" : "", ...(product.collections || []).flatMap((c) => [c.name, c.nameEn, c.slug])].join(" ");
  const content = normalize(`${product.id} ${product.name} ${product.number} ${product.description || ""} ${collection}`);
  return search.every((word) => content.includes(word));
}

export function filterCatalog(products, params) {
  const minimum = params.get("min");
  const maximum = params.get("max");
  const result = products.filter((p) => catalogMatches(p, params.get("q") || "")
    && (!minimum || p.priceCents >= Number(minimum) * 100)
    && (!maximum || p.priceCents <= Number(maximum) * 100));
  if (params.get("sort") === "price_asc") result.sort((a, b) => a.priceCents - b.priceCents);
  if (params.get("sort") === "price_desc") result.sort((a, b) => b.priceCents - a.priceCents);
  return result;
}

export function readFavorites(storage) {
  try {
    storage ??= globalThis.localStorage;
    const stored = JSON.parse(storage.getItem("ko-favorites-v1") || "[]");
    return Array.isArray(stored) ? [...new Set(stored.filter((id) => PRODUCT_ID_PATTERN.test(id)))].slice(0, 100) : [];
  } catch { return []; }
}

export function toggleFavorite(id, storage) {
  if (!PRODUCT_ID_PATTERN.test(id)) return readFavorites(storage);
  const saved = readFavorites(storage);
  const next = saved.includes(id) ? saved.filter((item) => item !== id) : [...saved, id].slice(0, 100);
  try {
    (storage ?? globalThis.localStorage).setItem("ko-favorites-v1", JSON.stringify(next));
    return next;
  } catch { return saved; }
}

export function deliverySummary(subtotalCents) {
  return subtotalCents >= FREE_DELIVERY_THRESHOLD_CENTS
    ? "Доставка безкоштовна. Час отримання підтвердить флорист."
    : "Доставка лише в межах Львова - 350 грн. Від 3500 грн за букети доставка безкоштовна. Дату й час отримання підтвердить флорист.";
}
